(function () {
	const searchModal = () => {
		// Mobile trigger (icon button) — opens full modal
		$(".search-modal__overlay,.search__close,.mega-menu__search-mobile-trigger").click(
			function (e) {
				e.preventDefault();
				searchToggle();
			}
		);

		// Desktop utility bar input — opens dropdown on focus/type
		var $triggerInput = $('[data-search-trigger-input]');
		var $modalInput = $('#Search-In-Modal');

		if ($triggerInput.length && $modalInput.length) {
			$triggerInput.on('input', function () {
				var val = $(this).val();
				$modalInput.val(val);

				// Open modal if not already open
				if (!$('#search-modal').hasClass('active')) {
					$('#search-modal').addClass('active');
				}

				// Trigger the predictive search input event
				$modalInput[0].dispatchEvent(new Event('input', { bubbles: true }));
			});

			$triggerInput.on('focus', function () {
				if (!$('#search-modal').hasClass('active')) {
					$('#search-modal').addClass('active');
				}
			});

			// Close search when clicking overlay
			$(document).on('click', function (e) {
				if ($('#search-modal').hasClass('active') && window.innerWidth >= 990) {
					var $target = $(e.target);
					if ($target.closest('.search-modal__panel').length === 0 &&
						$target.closest('.mega-menu__search-trigger').length === 0) {
						$('#search-modal').removeClass('active');
						$triggerInput.val('');
						$modalInput.val('');
						$modalInput[0].dispatchEvent(new Event('input', { bubbles: true }));
					}
				}
			});
		}
	};

	$(document).on('keyup', function(e) {
		if ($(".search-modal").hasClass('active') && e.key == "Escape") {
			searchToggle();
		}
	});

	function searchToggle(){
		var $modal = $("#search-modal");
		var isOpen = $modal.hasClass('active');

		if (isOpen) {
			// Closing
			$modal.removeClass("active");
			$('[data-search-trigger-input]').val('');
			$('#Search-In-Modal').val('');
			var modalInput = document.getElementById('Search-In-Modal');
			if (modalInput) modalInput.dispatchEvent(new Event('input', { bubbles: true }));
			if (window.innerWidth < 990) {
				$('body').removeClass("overflow-hidden");
			}
			removeFocusTrap();
		} else {
			// Opening
			$modal.addClass("active");
			if (window.innerWidth < 990) {
				$('body').addClass("overflow-hidden");
				setupFocusTrap($modal[0]);
			}
			setTimeout(function() {
				if (window.innerWidth < 990) {
					$modal.find('.search__input').focus();
				}
			}, 100);
		}
	}

	var focusTrapHandler = null;

	function setupFocusTrap(modal) {
		removeFocusTrap();
		focusTrapHandler = function(e) {
			if (e.key !== 'Tab') return;
			var focusable = modal.querySelectorAll(
				'input:not([type="hidden"]):not([disabled]), button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
			);
			var visible = Array.prototype.filter.call(focusable, function(el) {
				return el.offsetParent !== null;
			});
			if (!visible.length) return;
			var first = visible[0];
			var last = visible[visible.length - 1];
			if (e.shiftKey && document.activeElement === first) {
				e.preventDefault();
				last.focus();
			} else if (!e.shiftKey && document.activeElement === last) {
				e.preventDefault();
				first.focus();
			}
		};
		modal.addEventListener('keydown', focusTrapHandler);
	}

	function removeFocusTrap() {
		if (focusTrapHandler) {
			var modal = document.getElementById('search-modal');
			if (modal) modal.removeEventListener('keydown', focusTrapHandler);
			focusTrapHandler = null;
		}
	}

	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();
